import { TooltipProvider } from "@radix-ui/react-tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import { Navigate, Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { ScrollToTop } from "./components/layout/ScrollToTop";
import { LanguageProvider } from "./context/LanguageContext";
import { ThemeProvider } from "./context/ThemeContext";
import { trackPromotionalFunnelEvent } from "./lib/analytics";
import Contact from "./pages/Contact";
import Document from "./pages/Document";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import Products from "./pages/Products";

const PricingRedirect = () => {
  useEffect(() => {
    trackPromotionalFunnelEvent("view_pricing_redirect", {
      surface: "legacy_pricing_route",
      funnel_stage: "product_discovery",
      result_status: "redirected_to_products",
    });
  }, []);

  return <Navigate to="/products" replace />;
};

const App = () => {
  const queryClient = new QueryClient();

  // Set custom CSS variables for brand colors
  useEffect(() => {
    document.documentElement.style.setProperty("--brand-blue", "#0066FF");
    document.documentElement.style.setProperty("--brand-blue-dark", "#0052CC");
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <ThemeProvider>
          <LanguageProvider>
            <HelmetProvider>
              <Toaster />
              <Router>
                <ScrollToTop />
                <Routes>
                  <Route path="/" element={<Index />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/document" element={<Document />} />
                  <Route path="/products" element={<Products />} />
                  <Route path="/pricing" element={<PricingRedirect />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </Router>
            </HelmetProvider>
          </LanguageProvider>
        </ThemeProvider>
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;
